/** The plain words on a card's tag row: category, severity and timing as a player reads them (never "severity 2", never a code). */
import type { EventForTeam } from "@bsim/contracts";

const CATEGORY: Readonly<Record<EventForTeam["card"]["category"], string>> = {
  liquidity: "Liquidity", credit: "Credit", regulatory: "Regulatory", governance: "Governance", strategic: "Strategy", macro: "Interest rates",
};
const SEVERITY: Readonly<Record<number, string>> = { 1: "Low severity", 2: "Moderate severity", 3: "High severity" };

export const categoryWord = (c: EventForTeam["card"]["category"]): string => CATEGORY[c];
export const severityWord = (s: number): string => SEVERITY[s] ?? "Moderate severity";
export const timingWord = (t: EventForTeam["timing"]): string => (t.phase === "roundStart" ? "Known at the start of the year" : `Arrives in month ${t.month}`);
